module.exports = __webpack_public_path__ + "img/cover.732b5c23.webp";